import {
  ReservedCatalogInfoField,
  ReservedCatalogInfoFields,
  SkeletonParameters,
} from './types';
import { RESERVED_CATALOG_INFO_FIELDS } from './constants';
import _ from 'lodash';

export function updateReservedParameters<
  T extends keyof ReservedCatalogInfoFields,
>(options: {
  entityType: T;
  parameters: SkeletonParameters;
  updates: Map<keyof ReservedCatalogInfoFields[T], any>;
}): SkeletonParameters {
  const updatedParameters = _.cloneDeep(options.parameters);
  const fields = RESERVED_CATALOG_INFO_FIELDS[options.entityType];

  for (const [key, value] of options.updates.entries()) {
    const field = fields[key] as ReservedCatalogInfoField;
    _.set(updatedParameters, field.skeletonParameter, value);
  }

  return updatedParameters;
}

/**
 * Sets the missing reserved parameters values from the catalog info
 */
export function fillMissingReservedParametersFromCatalogInfo({
  catalogInfo,
  parameters,
}: {
  catalogInfo: Record<string, any>;
  parameters: SkeletonParameters;
}): SkeletonParameters {
  let reservedFields: Record<string, ReservedCatalogInfoField>;
  const catalogInfoKind = _.isString(catalogInfo.kind)
    ? catalogInfo.kind.toLocaleLowerCase('en-US')
    : undefined;

  switch (catalogInfoKind) {
    case 'system':
      reservedFields = RESERVED_CATALOG_INFO_FIELDS.system;
      break;
    case 'component':
      reservedFields = RESERVED_CATALOG_INFO_FIELDS.component;
      break;
    default:
      return parameters;
  }

  for (const { path: fieldPath, skeletonParameter } of Object.values(
    reservedFields,
  )) {
    if (_.has(parameters, skeletonParameter)) continue;

    const resolvedValue = _.get(catalogInfo, fieldPath, undefined);

    if (resolvedValue !== undefined)
      _.set(parameters, skeletonParameter, resolvedValue);
  }

  return parameters;
}
